import {Component, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'dropdown-option',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class DropdownOptionComponent {
  @ViewChild(TemplateRef) template: TemplateRef<any>;
}
